import { Router } from '@angular/router';
import { FormStore } from './../common/form.store';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebformPdfService } from '../services/webform-pdf.service';

@Component({
    selector: 'success-page',
    templateUrl: './success-page.component.html',
    styleUrls: ['success-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SuccessPageComponent implements OnInit {

  public successMessage = '';
  public downloading = false;
  private defaultMessage = 'Your form has been successfully submitted';

  /** Download PDF is offered only while this browser still holds the submitted answers. */
  public get canDownload(): boolean {
    return !!FormStore.lastSubmission?.clientInputContents?.length;
  }

  constructor(
    router: Router,
    private webformPdfService: WebformPdfService,
    private alert: ToastrService
  ) {
    const state: any = router.getCurrentNavigation()?.extras?.state;
    if (state?.successMessage) {
      this.successMessage = state.successMessage;
      this.setMessage(this.successMessage);
    } else {
      this.successMessage = this.getMessage();
    }
  }

  ngOnInit() {
  }

  public downloadPdf(): void {
    const copy = FormStore.lastSubmission;
    if (!copy || this.downloading) return;
    this.downloading = true;
    this.webformPdfService.download(copy).subscribe({
      next: (blob) => {
        this.downloading = false;
        this.webformPdfService.save(blob, copy.formTitle);
      },
      error: () => {
        this.downloading = false;
        this.alert.error('The PDF could not be created. Please try again.');
      }
    });
  }

  private setMessage(successMessage: string) {
    try {
      localStorage.setItem(FormStore.successMsgKey, successMessage);
    } catch (e) { }
  }

  private getMessage() {
    try {
      const msg = localStorage.getItem(FormStore.successMsgKey);
      if (msg) {
        return msg;
      } else {
        return this.defaultMessage;
      }
    } catch (e) {
      return this.defaultMessage;
    }
  }

}
